import {
  Badge,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { ReactComponent as BackIcon } from 'assets/icons/chevron_left.svg';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ChatContainer } from './ChatContainer';
import { DesignAIModalContentProps, DesignAIModalProps } from './DesignAI.types';

export const DesignAIModal = ({ isOpen, onClose }: DesignAIModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='4xl' trapFocus={false}>
      <ModalOverlay />
      <DesignAIModalContent onClickBack={onClose} />
    </Modal>
  );
};

const DesignAIModalContent = memo(({ onClickBack }: DesignAIModalContentProps) => {
  const { t } = useTranslation('design_generator', { keyPrefix: 'designAI' });

  return (
    <ModalContent height='xl' m={{ base: 4, lg: 0 }}>
      <ModalHeader p='6'>
        <Flex alignItems={'center'}>
          <Button
            display={{ base: 'none', md: 'block' }}
            onClick={onClickBack}
            leftIcon={<BackIcon style={{ marginRight: '0.5rem' }} />}
            size='xs'
            variant='ghost'
            position='absolute'
          >
            {t('backButton')}
          </Button>
          <Heading
            display='flex'
            alignItems='center'
            justifyContent='center'
            width='full'
            textAlign='center'
            fontSize='xl'
          >
            {t('heading')}
            <Badge variant='solid' colorScheme='green' ml='2' lineHeight='base' fontWeight='medium'>
              BETA
            </Badge>
          </Heading>
        </Flex>
        <ModalCloseButton m='2.5' />
      </ModalHeader>
      <ModalBody pl='6' pb='6' pr='2' overflow='hidden'>
        <ChatContainer />
      </ModalBody>
    </ModalContent>
  );
});

DesignAIModalContent.displayName = 'DesignAIModalContent';
